type FsOption = any;

export interface WindowPlacementApiElement extends Element {
  requestFullscreen: (fullScreenOptions: FsOption) => Promise<void>;
}

export interface WindowPlacementApiWindow extends Window {
  getScreenDetails?: () => ScreenDetails;
}

export interface ScreenDetails extends EventTarget {
  screens: WindowPlacementScreens;
}

export interface WindowPlacementScreen extends Screen {
  isPrimary?: boolean;
}

export type WindowPlacementScreens = Array<WindowPlacementScreen>;

export const SCREEN_CHANGE_EVENT = 'screenschange';

export const windowPlacementApiWindow: WindowPlacementApiWindow = window;
export const windowPlacementApiBody: WindowPlacementApiElement = document.body;
